import { InputText as e } from "./index.js";
import { cn as t } from "../../cn.js";
import { Search as n, X as r } from "lucide-react";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
// src/design/forms/input-text/presets.tsx
var o = ({ className: o, config: s = { size: "sm" }, value: c, onClear: l, disabled: u, clearLabel: d = "Clear search", ...f }) => {
	let p = c !== void 0 && c !== "" && c !== null;
	return /* @__PURE__ */ a("div", {
		className: "relative w-full max-w-xs group",
		children: [
			/* @__PURE__ */ i("div", {
				className: "absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none",
				children: /* @__PURE__ */ i(n, { size: 14 })
			}),
			/* @__PURE__ */ i(e.Input, {
				...f,
				value: c,
				disabled: u,
				config: s,
				style: {
					paddingLeft: "32px !important",
					paddingRight: p ? "28px !important" : "8px !important"
				},
				className: t("bg-muted border-border rounded-md", "!pl-7 py-1", p ? "!pr-7" : "!pr-2", "hover:bg-transparent", "focus-visible:!ring-2 focus-visible:!ring-primary focus-visible:!ring-offset-2", "focus-visible:!bg-back", "focus-visible:!border-border", s?.size === "sm" && "h-8 text-xs", s?.size === "md" && "h-9 text-sm", s?.size === "lg" && "h-10 text-md", o)
			}),
			p && !u && /* @__PURE__ */ i("button", {
				type: "button",
				"aria-label": d,
				onClick: (e) => {
					e.stopPropagation(), l?.();
				},
				className: "absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center size-6 rounded-sm hover:bg-accent cursor-pointer text-muted-foreground hover:text-foreground shrink-0 transition-colors focus-ring",
				children: /* @__PURE__ */ i(r, { size: 14 })
			})
		]
	});
};
export { o as FilterSearchInput };

//# sourceMappingURL=presets.js.map